import Vue from "vue";
import VueCookies from "vue-cookies";
import App from "./App/App.vue";
import router from "./shared/router";
import store from "./shared/store";
import BaseMixin from "./shared/mixin/BaseMixin";
import BaseService from "./shared/services/BaseService";
import VueObserveVisibility from "vue-observe-visibility";
import VueScrollTo from "vue-scrollto";
import "./shared/helpers/HighchartConfig";

require("dotenv").config();

// Validações
import "unimed-components/src/Validation/validation";

// Componentes do rnp
import "./shared/components/index";

// Componentes do unimed-components
import UnimedComponentes from "unimed-components";

// css do unimed componentes
import "unimed-components/dist/unimed-components.css";

BaseMixin.Start();
BaseService.Start();

Vue.config.productionTip = false;

Vue.use(UnimedComponentes);
Vue.use(VueObserveVisibility);
Vue.use(VueScrollTo);
Vue.use(VueCookies);

const app = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

window.app = app;
window.$helpers = Vue.prototype.$helpers;
